import * as rmd from 'material-ui';
import React from 'react';

class TextFieldPicker extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            value: props[props.propKey] || '',
        };
    }

    onChange = e => {
        const value = e.target.value;
        this.setState({ value });
    };

    handleOnBlur = () => {
        this.props.onChange(this.props.propKey, this.state.value);
    };

    render() {
        return (
            <rmd.TextField
                value={this.state.value || ''}
                onChange={this.onChange}
                onBlur={this.handleOnBlur}
                errorText={this.props.error}
                floatingLabelText={this.props.label || `${this.props.propKey}`}
            />
        );
    }
}

export default TextFieldPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/TextFieldPicker.js
 **/